import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from './ElectronicHealthCardContactInfoContactPersonsWrapper.module.scss';
import ElectronicHealthCardContactInfoContactPersons from './ElectronicHealthCardContactInfoContactPersons';
import NCZIEditContactPersonModal from '../EditContactPersonModal/NCZIEditContactPersonModal';
import { useNCZIContext } from '../../../../Services/NCZIContext';
import useNCZI from '../../../../Hooks/useNCZI';
import { useEffectAsync } from '../../../../../../helpers';

interface Props {
	patientIdentifier: string;
	setLoadingCommandId: (id: string) => void;
}

const ElectronicHealthCardContactInfoContactPersonsWrapper: React.FC<Props> = ({
	patientIdentifier,
	setLoadingCommandId,
}) => {
	const [isAddOpen, setIsAddOpen] = useState<boolean>(false);
	const { patientSummaryContactData } = useNCZIContext();
	const { fetchPatientSummaryContactData } = useNCZI();
	const [initialized, setInitialized] = useState(true);

	const handleLoadPatientContactData = async () => {
		if (patientIdentifier) {
			const command = await fetchPatientSummaryContactData(patientIdentifier);
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};
	const handleCloseEdit = async (needReload: boolean) => {
		setIsAddOpen(false);
		if (needReload) {
			await handleLoadPatientContactData();
		}
	};

	if (!patientSummaryContactData?.contactPersons) {
		return <></>;
	}

	useEffect(() => {
		setInitialized(false);
		setInitialized(true);
	}, [patientSummaryContactData.contactPersons]);

	if (!initialized) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<ElectronicHealthCardContactInfoContactPersons
				contacts={patientSummaryContactData.contactPersons}
				patientIdentifier={patientIdentifier}
				handleReloadData={handleLoadPatientContactData}
				handleAdd={() => setIsAddOpen(true)}
			/>
			<NCZIEditContactPersonModal
				patientIdentifier={patientIdentifier}
				opened={isAddOpen}
				onClose={handleCloseEdit}
			/>
		</div>
	);
};

export default ElectronicHealthCardContactInfoContactPersonsWrapper;
